import React, { Fragment } from 'react'
import { AppMaskLayer } from 'qcc'
import { AppTableProps, AppTableServer, handleScroll } from './AppTableServer'
import { AppPagination, defaultPagination } from './AppPagination'
import { AppTableHeader } from './AppTableHeader'
import { AppTableBody } from './AppTableBody'
import { Empty, Layout } from 'antd'
import './index.less'
import { AppFilter } from 'qcc'
import api, { AppTableQuery, AppTableList } from 'api'
import ResizeObserver from 'resize-observer-polyfill'

export interface AppTableContext {
	dataList?: any[]
	actived?: any
	hovered?: any
	keyName?: string
	handleRowClick?: (data: any) => void
	handleRowHover?: (data: any) => void
	handleCheck?: (data: any, checked: boolean) => void
	handleCheckAll?: (checked: boolean) => void
	hanldPagination?: (current: number, pageSize: number) => void
	handleExpand?: (data: any) => void
	handleUpdateData?: (dataIndex: number, field: string, value: any) => void
	handleSort?: (sortType: string, sortField?: string) => void
}

export const AppTableContext = React.createContext<AppTableContext>({} as AppTableContext)


export class AppTableProvider extends React.Component<AppTableProps>{

	appTableServer = new AppTableServer({ ...this.props })

	resizeObserver = new ResizeObserver((entries, observer) => {
		this.handleResize()
	})

	state = {
		pagination: { ...defaultPagination },
		keyName: this.props.keyName || 'id',
		loading: true,
		dataList: undefined as any[],
		actived: {} as any,
		hovered: {} as any,
		layout: this.appTableServer.getLayout(),
		orderBy: this.props.orderBy || 'id',
		expandLevel: this.props.expandLevel || 3,
		queryData: this.props.queryData || {},
		queryDataList: this.props.queryDataList || [],
		queryMode: this.props.queryMode || 1
	}

	async componentDidMount() {
		this.reloadLayout();
		this.refMainBody
			&& this.refMainBody.current
			&& this.refMainBody.current.addEventListener('scroll', handleScroll)

		if (typeof this.props.dataSource !== 'undefined') {
			this.updateDataSource(this.props.dataSource);
		} else {
			await this.fetchData();
		}

		window.addEventListener('resize', this.handleResize)
		this.resizeObserver.observe(document.getElementsByClassName('app-table')[0])
	}

	componentWillUnmount(): void {
		window.removeEventListener('resize', this.handleResize)
		this.resizeObserver.disconnect()
	}

	reloadLayout = () => {
		if (this.refMainContent && this.refMainContent.current) {
			let headerHeight = this.refMainHeader.current.offsetHeight;
			let height = this.refMainContent.current.clientHeight;
			let width = this.refMainContent.current.clientWidth;
			let { layout } = this.state
			if (layout.headerHeight !== headerHeight
				|| layout.height !== height
				|| layout.width !== width) {
				layout = { ...layout, headerHeight, height, width }
				this.setState({ layout })
			}
		}
	}

	// 重新绘制固定区域的内容
	reLayoutFixArea = () => {
		if (this.refMainBody.current) {
			let { layout } = this.state
			let { clientWidth, offsetWidth, clientHeight, offsetHeight } = this.refMainBody.current
			let xScroll = offsetHeight - clientHeight;
			let yScroll = offsetWidth - clientWidth;
			// y轴有滚动条 右边固定区域需往左偏移一个滚动条的位置 
			// x轴有滚动条 左边和右边区域均需要网上偏移一个滚动条的位置
			if (layout.xScroll !== xScroll || layout.yScroll !== yScroll) {
				layout = { ...layout, xScroll, yScroll }
				this.setState({ layout })
			}
		}
	}

	updateDataSource = (dataSource: any[]) => {
		let { expandLevel, pagination } = this.state
		let { current, pageSize } = pagination;
		let bgnIndex = this.props.paging ? (current - 1) * pageSize : 0;
		let selected = this.props.selected || [];
		let dataList = this.appTableServer.handleList(dataSource, bgnIndex, expandLevel, selected);
		this.setState({ dataList, loading: false })
	}


	onQuery = async (filterList?: AppFilter[], data?: any) => {
		filterList = filterList || [];
		let initQueryDataList = this.props.queryDataList || [];
		let initQueryData = this.props.queryData || {};
		let queryDataList = [...initQueryDataList, ...filterList];
		let queryData = { ...initQueryData, ...data };
		this.setState({ queryDataList, queryData }, this.fetchData);
	}

	getQueryData = () => {
		return this.state.queryData || {};
	}

	getQueryFilterList = () => {
		return this.state.queryDataList || {};
	}

	getAppTableQuery = () => {
		let { queryDataList, pagination, orderBy } = this.state;
		let { current, pageSize } = pagination;
		let { sqlId } = this.props;
		let appTableQuery = { size: pageSize!, page: current, sqlId, paging: this.props.paging!, orderBy, filterList: queryDataList } as AppTableQuery;
		return appTableQuery;
	}

	fetchData = async () => {
		// 优先级  api -> apiPath -> sqlId
		if (this.props.onBeforeApi && !this.props.onBeforeApi(this.state.queryData)) return;
		let apiResult = this.props.api ? await this.handleApi() : await this.getListBySqlId();

		let { pagination, expandLevel } = this.state;
		let { current, pageSize } = pagination;
		let bgnIndex = this.props.paging ? (current - 1) * pageSize : 0;
		let selected = this.props.selected || [];

		let dataList = this.appTableServer.handleList(apiResult.list, bgnIndex, expandLevel, selected);
		pagination = { ...pagination, total: apiResult.total! }
		this.setState({ dataList, loading: false, pagination })

	}

	handleApi = async () => {
		let { queryMode, queryData, queryDataList, pagination, orderBy } = this.state;
		let { current, pageSize } = pagination;
		let queryParam = queryMode === 1 ? queryDataList : queryData;
		let pageParam = { size: pageSize!, page: current, paging: this.props.paging!, orderBy } as any;
		if (queryMode === 1) {
			pageParam = { ...pageParam, ...queryParam };
		} else {
			pageParam = { ...pageParam, filterList: queryParam };
		}
		return await this.props.api(queryParam);
	}


	getListBySqlId = async () => {
		let { queryDataList, pagination, orderBy } = this.state;
		let { current, pageSize } = pagination;
		let { sqlId } = this.props;
		if (sqlId === undefined || sqlId === '') {
			return { list: [], total: 0 }
		}
		let appTableQuery = { size: pageSize!, page: current, sqlId, paging: this.props.paging!, orderBy, filterList: queryDataList } as AppTableQuery;
		return await api.public.component.getTableList(appTableQuery);
	}

	getSelected = () => {
		let { dataList } = this.state;
		return dataList.filter(e => e._table_checked) || [];
	}

	handleRowClick = (actived: any) => {
		this.props.rowClick && this.props.rowClick(actived)
		this.setState({ actived })
	}

	handleRowHover = (hovered: any) => {
		hovered = hovered || {}
		this.setState({ hovered })
	}

	handleCheck = (data: any, checked: boolean) => {
		let dataList = this.appTableServer.handleCheck(data, checked)
		this.setState({ dataList })
	}

	handleCheckAll = (checked: boolean) => {
		let dataList = this.appTableServer.handleCheckAll(checked)
		this.setState({ dataList })
	}


	hanldPagination = (current: number, pageSize: number) => {
		let pagination = { ...this.state.pagination, current, pageSize }
		this.setState({ pagination }, this.fetchData)
	}

	handleExpand = (data: any) => {
		let dataList = this.appTableServer.handleTreeClick(data)
		this.setState({ dataList })
	}

	handleUpdateData = (dataIndex: number, field: string, value: any) => {
		let dataList = this.appTableServer.handleUpdateData(dataIndex, field, value)
		this.setState({ dataList })
	}

	handleSort = (sortType: string, sortField?: string) => {
		console.log('handleSort')
	}

	handleResize = () => {
		this.reloadLayout()
	}




	renderContentRight = () => {
		let { right, height, yScroll, headerHeight, xScroll } = this.state.layout
		let { dataList } = this.state;
		let { columns, columsWidth } = right;
		if (columns.length === 0 || dataList === undefined) return <React.Fragment />
		let bodyHeight = height - headerHeight - xScroll
		return (
			<div className="app-table-content-right" style={{ marginRight: yScroll }}>
				<div className="app-table-header-fixed" style={{ width: columsWidth }} >
					<AppTableHeader columns={columns} />
				</div>
				<div className="app-table-body-right-fixed" style={{ width: columsWidth, height: bodyHeight }}>
					<AppTableBody columns={columns} width={columsWidth} />
				</div>
			</div>
		)
	}

	renderContentLeft = () => {
		let { left, height, headerHeight, xScroll } = this.state.layout
		let { dataList } = this.state;
		let { columns, columsWidth } = left;
		if (columns.length === 0 || dataList === undefined) return <React.Fragment />
		let bodyHeight = height - headerHeight - xScroll
		return (
			<div className="app-table-content-left" style={{ width: columsWidth, display: 'none' }}>
				<div className="app-table-header" style={{ width: columsWidth }}>
					<AppTableHeader columns={columns} />
				</div>
				<div className="app-table-body-left-fixed" style={{ height: bodyHeight, width: columsWidth }}>
					<AppTableBody columns={columns} width={columsWidth} />
				</div>
			</div>
		)
	}

	renderMainBody = () => {
		let { layout } = this.state
		let mainLayout = layout.main;
		let { dataList } = this.state;
		if (dataList === undefined) return <Fragment />
		if (dataList.length === 0) {
			return (
				<div style={{ width: '100%' }}>
					<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
				</div>
			)
		}
		let mainWidth = mainLayout.columsWidth <= layout.width ? -1 : mainLayout.columsWidth;
		return <AppTableBody
			columns={mainLayout.columns}
			width={mainWidth}
			afterLoad={this.reLayoutFixArea}
		/>
	}

	refMainContent = React.createRef<HTMLDivElement>();
	refMainHeader = React.createRef<HTMLDivElement>();
	refMainBody = React.createRef<HTMLDivElement>();

	renderContentMain = () => {
		let { layout } = this.state;
		let mainLayout = layout.main;
		if (mainLayout.columns.length === 0) return <React.Fragment />
		let mainWidth = mainLayout.columsWidth <= layout.width ? -1 : mainLayout.columsWidth;
		return (
			<div className="app-table-content-main" ref={this.refMainContent}>
				<div className="app-table-header" ref={this.refMainHeader} style={{ paddingRight: layout.yScroll }}>
					<div className="app-table-header-inner">
						<AppTableHeader columns={mainLayout.columns} width={mainWidth} />
					</div>
				</div>
				<div className="app-table-body"
					style={{ height: `calc(100% - ${layout.headerHeight}px)` }}
					ref={this.refMainBody}
				>
					{this.renderMainBody()}
				</div>
			</div>
		)
	}

	render() {
		let { keyName, dataList, actived, hovered } = this.state;
		let { handleRowClick, handleRowHover, handleExpand, handleUpdateData, handleSort, handleCheck, handleCheckAll, hanldPagination } = this;
		let providerValue = { keyName, dataList, actived, hovered, handleRowClick, handleRowHover, handleExpand, handleUpdateData, handleSort, handleCheck, handleCheckAll, hanldPagination };

		let contentHeight = this.props.paging ? 'calc(100% - 43px)' : '100%';

		return (<AppTableContext.Provider value={providerValue}>
			<div className='app-table'>
				{this.state.loading ? <AppMaskLayer /> : <React.Fragment />}
				<div className='app-table-container'>
					<div className='app-table-content'
						style={{ height: contentHeight }}
					>
						{this.renderContentMain()}
						{this.renderContentLeft()}
						{this.renderContentRight()}
					</div>
					{this.props.paging ? <AppPagination {...this.state.pagination} /> : <Fragment />}
				</div>
			</div>
		</AppTableContext.Provider>)
	}
}



// WEBPACK FOOTER //
// ./src/qcc/AppTable/AppTableProvider.tsx